// AccordionTopic displays related article list in the HCR topic page
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Scroll from 'react-scroll';

import { updateBreadcrumb } from '../actions/action-breadcrumb';
import { TOPIC } from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import { trackLink } from '../../lib/analytics-helper';

import CollapseSegment from '../../contactUs/components/common/CollapseSegment';

const exp = Page.getUserExperience();
const title = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
const home = `/${exp}/home`;
const topicPath = `/${exp}/topic`;

// Scroll
const scroll = Scroll.animateScroll;

const accordionFAQlimit = 10;
const showMoreText = i18n.message('smarthelp/contentToggle.content.showMore');

class AccordionTopic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowMore: false,
    };
    this.toggle = this.toggle.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
  }

  // To determine show/hide the faq.
  getCorrespondingClassShowMore(index, length) {
    if (!this.state.isShowMore) {
      if (length > accordionFAQlimit && index >= accordionFAQlimit) {
        return 'display-none';
      }
    }

    return 'display-block';
  }

  // L2 topic tree transition animation
  scollTopicToTop() {
    if (this.accodionContainer) {
      setTimeout(() => {
        const $topDistance = this.accodionContainer.getBoundingClientRect && this.accodionContainer.getBoundingClientRect().top;
        const options = {
          duration: 500,
          smooth: true,
        };
        if ($topDistance < 0) {
          scroll.scrollMore($topDistance - 100, options);
        }
      }, 400);
    }
  }

  toggle() {
    const topic = this.props.topic;
    const expanded = !this.props.expanded;
    this.props.onToggle(topic, expanded);
    const accordianState = expanded ? 'expanded' : 'collapsed';
    trackLink({ id: 'topicPage', link: `smarthelp-subtopic-expanded-collapsed|${topic && topic.id}|${accordianState}` });
    this.scollTopicToTop();
  }

  // Handle Key press for accessing the subTopics in the L2 topics
  handleKeyPress(event) {
    if (event.which === 13) {
      this.toggle();
    }
  }

  // Handle Key Press for click articles in the topics list
  handleArticleKeyPress(event, article, parentTopics, subTopics) {
    if (event.which === 13) {
      this.goToArticle(article, parentTopics, subTopics);
    }
  }

  goToArticle(article, parentTopics, subTopics) {
    const items = [];
    if (!Page.isMobileLayout()) {
      items.push({
        title,
        path: home,
        id: parentTopics.id,
      }, {
        title: parentTopics.articleTitle,
        path: `${topicPath}/${parentTopics.id}`,
        id: parentTopics.id,
      }, {
        title: subTopics.name,
        path: `${topicPath}/${parentTopics.id}`,
        id: subTopics.id,
      });
    } else {
      items.push({
        title: subTopics.name,
        path: `${topicPath}/${parentTopics.id}`,
        id: subTopics.id,
      });
    }
    this.props.updateBreadcrumb(items);
    trackLink({ id: 'topicPage', link: `smarthelp-article-page|${exp}|${article.articleId}` });
  }

  handleShowMoreClick(value) {
    this.setState({
      isShowMore: value,
    });
    const { parent, topic } = this.props;

    const fptiParentId = ((parent && parent.id) || '');
    const fptiTopicId = ((topic && topic.id) || '');

    trackLink({ id: 'topicPage', link: `smarthelp-article-page|${exp}|${fptiParentId}|${fptiTopicId}|showMoreExpanded` });
  }

  // to Render showMore button
  renderShowMoreButton(articleList) {
    if (this.state.isShowMore || articleList.faqList.length <= accordionFAQlimit) {
      return null;
    }
    return (
      <button className="vx_addBtn-primary" onClick={() => this.handleShowMoreClick(true)}>{showMoreText}</button>
    );
  }

  renderAccordionContent(articleList, parentTopics) {
    const subTopics = {
      id: articleList.id,
      name: articleList.name,
    };
    const listItems = articleList.faqList.map((article, index) => (
      <li
        key={article.articleId}
        className={`accordion-topic-list ${this.getCorrespondingClassShowMore(index, articleList.faqList.length)}`}
      >
        <a
          href={Page.getFullArticleURL(article)}
          onClick={() => this.goToArticle(article, parentTopics, subTopics)}
          onKeyPress={(event) => this.handleArticleKeyPress(event, article, parentTopics, subTopics)}
        >
          {article.articleTitle}
        </a>
      </li>
    ));

    return <ul>{listItems}</ul>;
  }

  render() {
    const { topic, parent } = this.props;

    return (
      <div
        className="accordion-topic-container"
        ref={(click) => { this.accodionContainer = click; }}
      >
        <CollapseSegment
          header={topic.name}
          className="accordion-topic-collapse"
          onClick={(e) => this.toggle(e)}
          open={this.props.expanded}
        >
          {this.renderAccordionContent(topic, parent)}
          {this.renderShowMoreButton(topic)}
        </CollapseSegment>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateBreadcrumb }, dispatch);
}

AccordionTopic.propTypes = {
  expanded: PropTypes.bool.isRequired,
  topic: PropTypes.shape(TOPIC).isRequired,
  onToggle: PropTypes.func.isRequired,
  updateBreadcrumb: PropTypes.func.isRequired,
  parent: PropTypes.shape({
    id: PropTypes.string,
    articleTitle: PropTypes.string,
  }).isRequired,
};

export default connect(null, mapDispatchToProps)(AccordionTopic);
